import { Typography } from '@design-system/components/typography/typography';
import { WorkoutItemMenu } from './WorkoutItemMenu';
import { MenuItems } from '../view-models/workoutEdit.viewModel';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { clsx } from 'clsx';

export const SectionHeader = ({
  title,
  menuItems,
  icon,
  iconTestId,
  isCircuit,
  readonly,
}: {
  title: string;
  menuItems?: MenuItems;
  icon?: IconProp;
  iconTestId?: string;
  isCircuit?: boolean;
  readonly?: boolean;
}) => (
  <div
    className={clsx(
      'w-full px-4 py-4 rounded-t-xl flex justify-between items-center p-2',
      isCircuit && 'bg-[#E4E4E4] shadow-exercise',
      !isCircuit && 'bg-black',
    )}
    data-testid="sectionHeader"
  >
    <div className="flex items-center">
      {icon ? (
        <FontAwesomeIcon
          icon={icon}
          data-testid={iconTestId}
          className={clsx(
            'pr-2 ',
            isCircuit && 'text-black',
            !isCircuit && 'text-white',
          )}
        />
      ) : null}
      <Typography
        variant="title"
        className={clsx(isCircuit && 'text-black', !isCircuit && 'text-white')}
      >
        {title}
      </Typography>
    </div>
    {menuItems ? (
      <WorkoutItemMenu
        items={menuItems}
        isCircuit={!!isCircuit}
        readonly={readonly}
      />
    ) : null}
  </div>
);
